var productCompare = function(){	
	var init = function(){
		var compareCheckBoxes = [].slice.call(document.getElementsByClassName('compareItem'));
		compareCheckBoxes.forEach(function(el, index, array){
			el.addEventListener("change", function(){
				var favList = el.parentNode.parentNode.parentNode.parentNode.parentNode;
				var prodID = favList.getElementsByClassName('product-id')[0].value;

				if(document.getElementById('compareBox')){
					toggleChecker(el);
				} else{
					ajaxActions.InitializeCompare(prodID);
				} 
				if(el.checked){
					el.classList.add('prod_chk_' + prodID);
				}
			});
		});
	},
	
	toggleChecker = function(e){
		var favoriteList = e.parentNode.parentNode.parentNode.parentNode.parentNode;
		var prodID = favoriteList.querySelector('.product-id').value;
		if(e.checked){
			if(document.getElementsByClassName('itemCompare').length == 4){
				CompareBox.AddCompareError("Oops! You can only compare up to 4 items.");
				e.checked = false;
				return false;
			} else{
				e.classList.add('prod_chk_' + prodID);
				CompareBox.RemoveCompareError();
				ajaxActions.GetThumbUrl(favoriteList);
			}
		} else{
			CompareBox.RemoveItemFromList(prodID);
			if(document.getElementsByClassName('itemCompare').length <= 1){
				CompareBox.AddCompareError("Oops! Please select at least two items to compare.");
			}
		}
	},
	
	CompareBox = (function(){
		var clickEvents= function(){
			var removeItemBtns = [].slice.call(document.getElementsByClassName('removeItem'));
			removeItemBtns.forEach(function(el, index, array){
				el.removeEventListener("click", removeThis);
				el.addEventListener("click", removeThis);
			});
			
			document.getElementById("compareItemsBtn").removeEventListener("click", startComparing);
			document.getElementById("compareItemsBtn").addEventListener("click", startComparing);
			
			document.getElementsByClassName("removeCompareBox")[0].removeEventListener("click", closeCompareBox);
			document.getElementsByClassName("removeCompareBox")[0].addEventListener("click", closeCompareBox);
		}, 
		removeThis = function(e){
			var prodID = e.currentTarget.previousElementSibling.value;
			removeItemFromList(prodID);
		},
		removeItemFromList = function(prodID){
			if(document.getElementsByClassName('itemCompare').length == 1){
				document.getElementsByClassName('removeCompareBox')[0].click();
				return false;
			}
			if (document.getElementsByClassName('itemCompare').length > 1) {
				document.getElementsByClassName('compareResult')[0].innerHTML = '';
			}
			if(document.querySelectorAll('input.' + 'prod_chk_' + prodID)[0]){
				document.querySelectorAll('input.' + 'prod_chk_' + prodID)[0].checked = false;
				document.querySelectorAll('input.' + 'prod_chk_' + prodID)[0].classList.remove('prod_chk_' + prodID);
			} 
			var prodComp = [].slice.call(document.getElementsByClassName('prod_comp_' + prodID));
			prodComp.forEach(function(el, index, array){
				el.parentNode.removeChild(el);
			});
			document.getElementsByClassName("removeItem")[0].focus();
		},
		addCompareError = function(errorText){
			var errorElement = '<p class="compareMsg text14 textDkRed semibold" role="alert" aria-atomic="true">' + errorText + '</p>';
			removeCompareError();
			document.getElementById("compareItemsBtn").insertAdjacentHTML("beforebegin", errorElement);
		},
		removeCompareError = function(){
			if(document.querySelector(".compareMsg")){
				document.querySelector(".compareMsg").parentNode.removeChild(document.querySelector(".compareMsg"));
			}
		},
		startComparing = function(){
			if(document.getElementsByClassName('itemCompare').length == 1){
				addCompareError("Oops! Please select at least two items to compare.");
			}else{
				document.getElementsByClassName('compareResult')[0].innerHTML = '';
				ajaxActions.CompareItems();
			}
		},
		closeCompareBox = function(){
			document.getElementById('compareBox').parentNode.removeChild(document.getElementById('compareBox'));
			var compareItems = [].slice.call(document.getElementsByClassName("compareItem"));
			compareItems.forEach(function(el, index, array){
				el.checked = false;
			});
			document.getElementsByClassName("boardMiscLinks")[0].getElementsByTagName("a")[0].focus();
		};
		return {
			ClickEvents: clickEvents,
			RemoveItemFromList: removeItemFromList,
			RemoveCompareError: removeCompareError,
			AddCompareError: addCompareError
		};
	})(),

	ajaxActions = (function(){
		var getThumbUrl = function(favList){
			var prodID = favList.getElementsByClassName('product-id')[0].value;
			
			fetch("/productcompare/getthumburl/" + prodID, { 
				method: 'GET', 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; // response.json() returns a promise
			}).then(function(response){
				document.getElementsByClassName("itemsToBeCompared")[0].insertAdjacentHTML('beforeend', response);
	                	document.getElementById('compareItemsBtn').focus();
	                	CompareBox.ClickEvents();
			}).catch(function(error){
				// place error handling here
			});
		},
		initializeCompare = function(productID){
			var queryString = "prodID=" + productID;
			
			fetch("/productcompare/init?" + queryString, { 
				method: 'GET', 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; // response.json() returns a promise
			}).then(function(response){
				document.getElementsByClassName("favPaging")[0].insertAdjacentHTML("afterend", response);
	            		document.getElementsByClassName('skipToCompare')[0].addEventListener("click", function(){
					document.getElementById('compareItemsBtn').scrollIntoView({behavior: "smooth"});
				       window.location.hash = '#';
				       document.getElementById('compareItemsBtn').focus();
				});
				CompareBox.ClickEvents();
			}).catch(function(error){
				// place error handling here
			});
		},
		
		compareItems = function(){
			document.getElementById("loadCompare").classList.remove("hide");
			
			var prodIDs = [];
			var itemsToCompare = [].slice.call(document.getElementsByClassName('itemCompare'));
			itemsToCompare.forEach(function(el, index, array){
				var prodID = el.getElementsByClassName('ProductID')[0].value;
				prodIDs.push(prodID);
			});
	
			fetch('/productcompare/index', { 
				method: 'POST', 
				body: JSON.stringify({ prodIDS: prodIDs }), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch' }
			}).then(function(response){
				return  (response.ok) ? response.text() : []; // response.json() returns a promise
			}).then(function(response){
				document.getElementsByClassName('compareResult')[0].innerHTML = response;
	                    	document.getElementById("loadCompare").classList.add("hide");
			}).catch(function(error){
				// place error handling here
			});
		};
		return {
			GetThumbUrl: getThumbUrl,
			CompareItems: compareItems,
			InitializeCompare: initializeCompare
		};
	})();

	return{
		init: init
	};
}; 

(function(){
	var compareFavorites = new productCompare();
	compareFavorites.init();
})();